export enum WrapperMode {
    Builder = 'Builder',
    Viewer = 'Viewer'
}
